import { useCallback } from 'react';

import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';

import { toggleCartDrawer } from '../../actions/cart';

export function useDrawerState() {
  const isDrawerOpen = useSelector(
    ({ cart }: RootStateOrAny) => cart?.cartDrawerIsOpen
  );
  const dispatch = useDispatch();
  const setIsDrawerOpen = useCallback(
    (v: boolean) => dispatch(toggleCartDrawer(v)),
    [dispatch]
  );
  return [isDrawerOpen, setIsDrawerOpen];
}
